import { render, staticRenderFns } from "./SearchFilterDropdown.vue?vue&type=template&id=540b540c&lang=pug&"
import script from "./SearchFilterDropdown.vue?vue&type=script&lang=ts&"
export * from "./SearchFilterDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SearchFilterDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540b540c')) {
      api.createRecord('540b540c', component.options)
    } else {
      api.reload('540b540c', component.options)
    }
    module.hot.accept("./SearchFilterDropdown.vue?vue&type=template&id=540b540c&lang=pug&", function () {
      api.rerender('540b540c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jobsearch-pages/SearchFilters/SearchFilterDropdown.vue"
export default component.exports